/**
 * Media sharing API client.
 */

import axios from "./axiosInstance";
import config from "./config";

const BASE_URL = config.BASE_URL;

export type ShareType = "user" | "all_staff" | "members" | "public";
export type SharePermission = "view" | "download" | "edit";

export interface MediaShare {
  id: string;
  media_id: string | null;
  folder_path: string | null;
  share_type: ShareType;
  shared_with_user_id: string | null;
  permission: SharePermission;
  shared_by: string;
  shared_by_name: string | null;
  share_token: string | null;
  expires_at: string | null;
  note: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateShareParams {
  media_id?: string;
  folder_path?: string;
  share_type: ShareType;
  shared_with_user_id?: string;
  permission?: SharePermission;
  note?: string;
  expires_at?: string;
  generate_link?: boolean;
}

export const createMediaShare = async (params: CreateShareParams): Promise<MediaShare> => {
  const res = await axios.post(`${BASE_URL}/media-shares`, params);
  return res.data?.data;
};

export const listMediaShares = async (filters?: {
  media_id?: string;
  folder_path?: string;
  share_type?: ShareType;
  my_shares?: boolean;
}): Promise<MediaShare[]> => {
  const res = await axios.get(`${BASE_URL}/media-shares`, { params: filters });
  return res.data?.data || [];
};

export const resolveShareToken = async (
  token: string
): Promise<{
  id: string;
  share_type: ShareType;
  permission: SharePermission;
  note: string | null;
  expires_at: string | null;
  shared_by_name: string | null;
  file: { name: string; type: string; url: string } | null;
  folder_path: string | null;
}> => {
  const res = await axios.get(`${BASE_URL}/media-shares/token/${token}`);
  return res.data?.data;
};

export const deleteMediaShare = async (id: string): Promise<void> => {
  await axios.delete(`${BASE_URL}/media-shares/${id}`);
};
